import React from 'react';
import './SecuritySettings.css';

export interface BiometricStatus {
  hasBiometric: boolean;
  deviceCount: number;
  maxDevices: number;
  canAddMore: boolean;
}

interface SecuritySettingsProps {
  biometricStatus: BiometricStatus | null;
  onOpenBiometricSetup: () => void;
}

const SecuritySettings: React.FC<SecuritySettingsProps> = ({
  biometricStatus,
  onOpenBiometricSetup,
}) => {
  return (
    <div className="biometric-section" data-testid="security-settings">
      <h3><span className="security-title-icon">🔐</span> SECURITY SETTINGS</h3>
      {biometricStatus ? (
        <div className="biometric-status">
          {biometricStatus.hasBiometric ? (
            <div className="biometric-enabled">
              <div className="status-indicator">
                <span className="status-icon">✅</span>
                <span className="status-text">Biometric Authentication Active for Customer</span>
              </div>
              <div className="device-info">
                <span>Devices registered: {biometricStatus.deviceCount}/{biometricStatus.maxDevices}</span>
              </div>
              {biometricStatus.canAddMore && (
                <button
                  className="add-biometric-btn"
                  onClick={onOpenBiometricSetup}
                >
                  Add Another Device
                </button>
              )}
            </div>
          ) : (
            <div className="biometric-disabled">
              <div className="status-banner">
                <span className="status-banner-icon">🔒</span>
                <span className="status-banner-text">
                  Biometric Authentication<br />Not Set Up
                </span>
              </div>
              <p>Enhance your security by adding biometric authentication to your account.</p>
              <button
                className="setup-biometric-btn"
                onClick={onOpenBiometricSetup}
              >
                Setup Biometric now
              </button>
            </div>
          )}
        </div>
      ) : (
        <div className="biometric-loading">
          <div className="loading-spinner-small">
            <div className="spinner"></div>
          </div>
          <span>Loading security settings...</span>
        </div>
      )}
    </div>
  );
};

export default SecuritySettings;
